import { ProductsVariantsApiRemoteService } from '../../Services/api/variants/products-variants-service'
import { IListProductsVariantsResponse } from '../../Services/api/variants/products-variants.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ListProductVariantsServiceUseCase
implements IFormUsecase<void, IListProductsVariantsResponse> {
  constructor (private readonly ProductsServiceApi: ProductsVariantsApiRemoteService) {}
    

  public async handle (): Promise<Result<IListProductsVariantsResponse>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ProductsServiceApi.list()

      if (response.isFailure) {
        return response
      }


      const list = response.getValue()

      if(!list) return response

    
      return Result.ok(list)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
